import React, { useCallback } from 'react';

import { Webchat as WebchatWidget, type WebchatSession } from '@eduzz-automacoes/webchat-widget';
import { API_MAP } from 'helpers/api';
import { WEBCHAT_CLIENT_ID, WEBCHAT_PROXY_URL } from 'settings';
import useGetOriginalUser from 'v2/hooks/useGetOriginalUser';
import useGetUser from 'v2/hooks/useGetUser';
import { apiServiceProxy } from 'v2/services/api-proxy';
import eduzzAccount from 'v2/services/eduzzAccount';

const Webchat = () => {
  const user = useGetUser();
  const originalUser = useGetOriginalUser();
  const isProducer = user?.producer || user?.coproducer || user?.affiliate;

  const beltName = !user?.current_elite_level?.id ? 'White' : eduzzAccount.getBeltById(user?.current_elite_level?.id);

  const definePresetSlug = () => {
    const BLACK_BELTS = new Set(['Black', 'Golden', 'Sensei']);

    if (user?.is_clube_black) return 'unity';

    return BLACK_BELTS.has(beltName.split(' ')[0]) ? 'black' : 'default-eduzz';
  };

  const getSession = useCallback(async (): Promise<WebchatSession> => {
    const { data } = await apiServiceProxy.post<WebchatSession>(`${API_MAP.generateChatUserCredentials}`, {});
    if (!data?.userToken) throw new Error('Webchat session not created or empty');
    return data;
  }, []);

  if (!isProducer || !user?.id) return null;

  const userKey = `${originalUser?.id}:${user?.id}`;

  return (
    <WebchatWidget
      clientId={WEBCHAT_CLIENT_ID}
      webchatProxyUrl={WEBCHAT_PROXY_URL}
      getSession={getSession}
      sessionKey={userKey}
      presetSlug={definePresetSlug()}
      storageKey={`myeduzz-webchat-${userKey}`}
      defaultUserData={{
        source: 'myeduzz-app'
      }}
    />
  );
};

export default Webchat;
